import type {
  AgChartOptions,
  AgRadialBarSeriesOptions
} from 'ag-charts-enterprise';
import { AgCharts } from 'ag-charts-react';

const RadialBarChart = ({
  data,
  series,
  total
}: {
  data: AgRadialBarSeriesOptions['data'];
  series: AgRadialBarSeriesOptions[];
  total?: number;
}) => {
  const options: AgChartOptions = {
    data,
    series,
    title: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    axes: {
      radius: {
        type: 'radius-category',
        innerRadiusRatio: 0.3,
        gridLine: {
          enabled: false
        },
        line: {
          enabled: false
        },
        label: {
          fontSize: 8,
          avoidCollisions: false
        },
        paddingInner: 0.4,
        paddingOuter: 0.4
      },
      angle: {
        type: 'angle-number',
        startAngle: 0,
        endAngle: 270,
        min: 0,
        max: total || 100, // Set max on the angle-number axis
        nice: false,
        label: {
          enabled: false
        },
        line: {
          enabled: false
        }
      }
    }
  };

  return <AgCharts style={{ height: '100%' }} options={options} />;
};

export default RadialBarChart;
